import { render, staticRenderFns } from "./policyDialog.vue?vue&type=template&id=244a5f84&scoped=true&"
import script from "./policyDialog.vue?vue&type=script&lang=js&"
export * from "./policyDialog.vue?vue&type=script&lang=js&"
import style0 from "./policyDialog.vue?vue&type=style&index=0&id=244a5f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a5f84",
  null
  
)

export default component.exports